var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{day: true, populated: _vm.isPopulated, active: _vm.isActive, bordered: _vm.isBordered},on:{"click":function($event){return _vm.selectDay()}}},[_vm._v("\n  "+_vm._s(_vm.day ? _vm.day.day : '')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }